<template>
    <el-dropdown
        ref="dropdown"
        trigger="click"
        :hide-on-click="false"
        @visible-change="handleChangeVisibility"
    >
        <el-button
            :disabled="isOpenFilterDropdown"
            class="el-dropdown-link btn-outline"
        >
            Filter
        </el-button>
        <el-dropdown-menu slot="dropdown" class="filter-dropdown-container">
            <h2 class="text-center" style="color:#606266; margin-bottom:40px;">Filter</h2>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
                align="center"
            >
                <el-col :span="9">
                    <span class="txt-filter">สถานะลูกค้า:</span>
                </el-col>
                <el-col :span="11" class="float-right">
                    <el-checkbox
                        :indeterminate="isUserStatusIndeterminate"
                        v-model="checkAllUserStatus"
                        @change="handleCheckAllUserStatusChange"
                    >
                        ทั้งหมด
                    </el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group
                        v-model="checkedUserStatus"
                        @change="handleUserStatusChange"
                    >
                        <el-checkbox
                            v-for="(item, index) in userStatusArr"
                            :key="index"
                            :label="item"
                        ></el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
                align="center"
            >
                <el-col :span="9" class="text-md-left">
                    <span class="txt-filter">สถานะแพ็กเกจ</span>
                </el-col>
                <el-col :span="11" class="float-right">
                    <el-checkbox
                        :indeterminate="isSubscriptionStatusIndeterminate"
                        v-model="checkAllSubscriptionStatus"
                        @change="handleCheckAllSubscriptionStatusChange"
                    >
                        ทั้งหมด
                    </el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="checkedSubscriptionStatus" @change="handleSubscriptionStatusChange">
                        <el-checkbox v-for="(item, index) in subscriptionStatusArr" :label="item" :key="index">{{item}}</el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                class="mt"
                type="flex"
                justify="space-between"
                align="center"
            >
                <el-col :span="9" class="text-md-left">
                    <span class="txt-filter">สถานะการยืนยันตัวตน</span>
                </el-col>
                <el-col :span="11" class="float-right">
                    <el-checkbox
                        :indeterminate="isApproveStatusIndeterminate"
                        v-model="checkAllApproveStatus"
                        @change="handleCheckAllApproveStatusChange"
                    >
                        ทั้งหมด
                    </el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group
                        v-model="checkedApproveStatus"
                        @change="handleApproveStatusChange"
                    >
                        <el-checkbox
                            v-for="(item, index) in approveStatusArr"
                            :key="index"
                            :label="item"
                        ></el-checkbox>
                    </el-checkbox-group>
                </el-col>
            </el-row>
            <el-row
                :gutter="20"
                style="margin-top:40px;"
                type="flex"
                justify="center"
                align="center"
            >
                <el-col :span="6">
                    <slot name="closeFilter" />
                </el-col>
                <el-col class="float-right" :span="6">
                    <slot name="searchFilter" />
                </el-col>
            </el-row>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
const AllUserStatus = [
    'Leadpool', 'Customer'
]
const AllSubscriptionStatus = [
    'New', 'Active', 'Expired'
]
const AllApproveStatus = [
    'ยังไม่ได้ยืนยันตัวตน', 'รอตรวจสอบ', 'ต้องการข้อมูลเพิ่มเติม', 'ยืนยันตัวตนสำเร็จ'
]
export default {
    name: 'FilterDropdownAllCustomer',
    props: {
        dateSort: { type: Boolean, default: true },
        fixedstatus: { type: Boolean, default: false },
        isOpenFilterDropdown: { type: Boolean, default: false },
        filterDropdownCase: { type: Object,
            default: () => ({
                account_status: { type: Number, default: null },
                package_code: { type: String, default: '' },
                subscription_type: { type: String, default: null },
                expire_within: { type: Boolean, default: false },
                subscription_status: { type: Array, default: null }
            })
        },
        handleChangeVisibility: { type: Function }
    },
    data () {
        return {
            isUserStatusIndeterminate: false,
            checkAllUserStatus: false,
            userStatusArr: AllUserStatus,
            checkedUserStatus: [],
            isSubscriptionStatusIndeterminate: false,
            checkAllSubscriptionStatus: false,
            subscriptionStatusArr: AllSubscriptionStatus,
            checkedSubscriptionStatus: [],
            subscriptionStatus: [],
            userStatus: [],
            isApproveStatusIndeterminate: false,
            checkAllApproveStatus: false,
            approveStatusArr: AllApproveStatus,
            checkedApproveStatus: [],
            approveStatus: []
        }
    },
    methods: {
        handleCheckAllUserStatusChange (val) {
            this.checkedUserStatus = val ? AllUserStatus : []
            if (this.checkedUserStatus.length === AllUserStatus.length) {
                this.onSelectUserStatus(-1)
            } else {
                this.onSelectUserStatus(null)
            }
            this.isUserStatusIndeterminate = false
            console.log()
        },
        handleUserStatusChange (value) {
            let checkedCount = value.length
            this.checkAllUserStatus = checkedCount === this.userStatusArr.length
            this.isUserStatusIndeterminate = checkedCount > 0 && checkedCount < this.userStatusArr.length
            this.userStatus = value
            this.onSelectUserStatus()
        },
        handleCheckAllSubscriptionStatusChange (val) {
            this.checkedSubscriptionStatus = val ? AllSubscriptionStatus : []
            if (this.checkedSubscriptionStatus.length === AllSubscriptionStatus.length) {
                this.onSelectSubscriptionStatus(-1)
            } else {
                this.onSelectSubscriptionStatus(null)
            }
            this.isSubscriptionStatusIndeterminate = false
        },
        handleSubscriptionStatusChange (value) {
            let checkedCount = value.length
            this.checkAllSubscriptionStatus = checkedCount === this.subscriptionStatusArr.length
            this.isSubscriptionStatusIndeterminate = checkedCount > 0 && checkedCount < this.subscriptionStatusArr.length
            this.subscriptionStatus = value
            this.onSelectSubscriptionStatus()
        },
        handleCheckAllApproveStatusChange (val) {
            this.checkedApproveStatus = val ? AllApproveStatus : []
            if (this.checkedApproveStatus.length === AllApproveStatus.length) {
                this.onSelectApproveStatus(-1)
            } else {
                this.onSelectApproveStatus(null)
            }
            this.isApproveStatusIndeterminate = false
        },
        handleApproveStatusChange (value) {
            let checkedCount = value.length
            this.checkAllApproveStatus = checkedCount === this.approveStatusArr.length
            this.isApproveStatusIndeterminate = checkedCount > 0 && checkedCount < this.approveStatusArr.length
            this.approveStatus = value
            this.onSelectApproveStatus()
        },
        onSelectUserStatus (val) {
            if (this.userStatus.length === 0 && val !== null) {
                this.userStatus.push(val)
            } else if (this.userStatus.length !== 0 && val === null) {
                this.userStatus = []
            }
            this.userStatus.forEach(e => {
                if (e === undefined) {
                    this.userStatus.splice(undefined, 1)
                } else {
                    if (this.userStatus.length === this.userStatusArr.length) {
                        this.userStatus = [-1]
                    }
                }
            })
            this.$emit('update:filterDropdownCase', { ...this.filterDropdownCase, user_status: this.userStatus })
        },
        onSelectSubscriptionStatus (val) {
            if (this.subscriptionStatus.length === 0 && val !== null) {
                this.subscriptionStatus.push(val)
            } else if (this.subscriptionStatus.length !== 0 && val === null) {
                this.subscriptionStatus = []
            }
            this.subscriptionStatus.forEach(e => {
                if (e === undefined) {
                    this.subscriptionStatus.splice(undefined, 1)
                } else {
                    if (this.subscriptionStatus.length === this.subscriptionStatusArr.length) {
                        this.subscriptionStatus = [-1]
                    }
                }
            })
            this.$emit('update:filterDropdownCase', { ...this.filterDropdownCase, subscription_status: this.subscriptionStatus })
        },
        onSelectApproveStatus (val) {
            if (this.approveStatus.length === 0 && val !== null) {
                this.approveStatus.push(val)
            } else if (this.subscriptionStatus.length !== 0 && val === null) {
                this.approveStatus = []
            }
            this.approveStatus.forEach(e => {
                if (e === undefined) {
                    this.approveStatus.splice(undefined, 1)
                } else {
                    if (this.approveStatus.length === this.approveStatusArr.length) {
                        this.approveStatus = [-1]
                    }
                }
            })
            this.$emit('update:filterDropdownCase', { ...this.filterDropdownCase, approve_status: this.approveStatus })
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-dropdown-container {
    width: 504px;
    padding: 24px 47px;
}
.mt {
    margin-top: 16px;
}
.el-checkbox:not(:first-child){
    margin-top: 1rem;
}
</style>
